import * as styles from "./StepConnector.module.scss";

/** Hand-drawn curved arrow between step cards (desktop only). */
export function StepConnector() {
	return (
		<svg
			className={styles["step-connector"]}
			viewBox="0 0 80 48"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			aria-hidden="true"
		>
			<path
				d="M6 38 C22 14 42 10 62 18 C70 22 74 22 74 22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
			<path
				d="M66 16 L74 22 L68 30"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
